import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'

// styles
import './CardList.css'

export default function ProjectList({ projects }) {
    const { mode } = useTheme()



    return (
        <div className='card-list'>
            {projects.map(project => (
                <div key={project.id} className={`card ${mode}`}>
                    <h3>{project.title}</h3>
                    <div className='icon-container'>
                        <img src={project.icon} alt={`${ project.title} icon`} className="card-icon"/>
                    </div>
                    <div className='date'>{project.date}</div>
                    <Link to={`/projects/${project.id}`}>Learn More</Link>
                </div>
            ))}
        </div>
    )
}